import { EventTypeType } from '../graphql-types';
import { GeneratedDocumentsTypeSlugs, GeneratedDocumentsTypeSlugsForDiary } from "./generatedDocumentsType.entity";
export enum EventTypeNamesEnum {
    Erschwernis = 'Erschwernis',
    Zusatzarbeit = 'Zusatzarbeit',
    BesonderesVorkommen = 'Besonderes Vorkommen',
    Leistungsaenderung = 'Leistungsänderung',
    Bedenkenanzeige = 'Bedenkenanzeige',
    Mangelanzeige = 'Mängelanzeige',
    /**
     * nur steinhoff
     */
    Auffaeligkeit = 'Auffälligkeit',
    /**
     * nur luksch
     */
    Dokumentation = 'Dokumentation',
    /**
     * nur luksch
     */
    Regiearbeit = 'Regiearbeit',
}
export const interruptionEventTypeNames = [
    EventTypeNamesEnum.Erschwernis,
    EventTypeNamesEnum.Mangelanzeige,
    EventTypeNamesEnum.Bedenkenanzeige,
    EventTypeNamesEnum.Zusatzarbeit,
    EventTypeNamesEnum.Dokumentation,
    EventTypeNamesEnum.Auffaeligkeit,
    EventTypeNamesEnum.Regiearbeit,
];
export enum EventTypeNamesShortEnum {
    Erschwernis = 'ERS',
    Zusatzarbeit = 'ZUS',
    BesonderesVorkommen = 'BES VOR',
    Leistungsaenderung = 'LEI',
    Bedenkenanzeige = 'BED',
    Mangelanzeige = 'MÄN',
    /**
     * nur steinhoff
     */
    Auffaeligkeit = 'AUF',
    /**
     * nur luksch
     */
    Dokumentation = 'DOK',
    /**
     * nur luksch
     */
    Regiearbeit = 'REG',
}
export enum EventTypeIdsEnum {
    Email = 1,
    OutgoingEmail = 4,
}
export class EventTypeEntity {
    constructor(public Id: number = null, public Name: EventTypeNamesEnum | string = null, public IsDefault: boolean = null, public ImagePath: string = null, public Markdown: string = null) {}
    get GeneratedDocumentsTypeSlugsForDiary(): GeneratedDocumentsTypeSlugsForDiary {
        switch (this.Name) {
            case EventTypeNamesEnum.Zusatzarbeit:
                return GeneratedDocumentsTypeSlugs.zusatzarbeit;
            case EventTypeNamesEnum.Mangelanzeige:
                return GeneratedDocumentsTypeSlugs.mangel;
            case EventTypeNamesEnum.Erschwernis:
                return GeneratedDocumentsTypeSlugs.erschwernis;
            case EventTypeNamesEnum.Bedenkenanzeige:
                return GeneratedDocumentsTypeSlugs.bedenken;
            case EventTypeNamesEnum.Auffaeligkeit:
                return GeneratedDocumentsTypeSlugs.auffaelligkeit;
            case EventTypeNamesEnum.Dokumentation:
                return GeneratedDocumentsTypeSlugs.dokumentation;
            case EventTypeNamesEnum.Regiearbeit:
                return GeneratedDocumentsTypeSlugs.regiearbeit;
            default:
                return null;
        }
    }
    public Clone(override: EventTypeEntityAttributes = {}): EventTypeEntity {
        const attr = { ...this, ...override };
        return Object.assign(new EventTypeEntity(), attr);
    }
}

export function EventTypeEntityFromBackend(res: EventTypeType): EventTypeEntity {
    return new EventTypeEntity(res.id, res.name, res.isDefault, res.imagePath, res.markdown);
}

export interface EventTypeEntityAttributes {
    Id?: number;
    Name?: string;
    IsDefault?: boolean;
    ImagePath?: string;
    Markdown?: string;
}
